import { MetricType } from 'components/common/types/DrilldownReports.types';
import { ProgrammaticAndDirectSalesBookingStatus } from 'components/common/types/Deal.types';
import { NO_METRICS_AVAILABLE_ERROR_MESSAGE } from './consts';
import { isLineIneligibleForDeliveredMetrics } from './utils';

type NotFoundError = {
  response?: {
    status?: number;
    data?: {
      detail?: unknown;
    };
  };
};

export const getNotFoundErrorDetail = (error: unknown): string | undefined => {
  const response = (error as NotFoundError | undefined)?.response;

  if (response?.status !== 404 || typeof response.data?.detail !== 'string' || !response.data.detail) {
    return undefined;
  }

  return response.data.detail;
};

export const getReportDataError = (results: PromiseSettledResult<unknown>[]): string | undefined => {
  const hasReport = results.some((result) => result.status === 'fulfilled' && result.value != null);

  if (hasReport) return undefined;

  const details = results
    .filter((result): result is PromiseRejectedResult => result.status === 'rejected')
    .map((result) => getNotFoundErrorDetail(result.reason));

  if (details.length === 0 || details.some((detail) => !detail)) return undefined;

  return NO_METRICS_AVAILABLE_ERROR_MESSAGE;
};

export const getDeliveredMetricsUnavailableMessage = (
  selectedMetricType: MetricType,
  lines: { lineStatus?: ProgrammaticAndDirectSalesBookingStatus }[],
): string | undefined => {
  if (lines.length === 0) return undefined;

  const areAllSelectedLinesIneligible = lines.every((line) =>
    isLineIneligibleForDeliveredMetrics(selectedMetricType, line.lineStatus),
  );

  return areAllSelectedLinesIneligible ? NO_METRICS_AVAILABLE_ERROR_MESSAGE : undefined;
};
